import { render, staticRenderFns } from "./Briva.vue?vue&type=template&id=4935160b&scoped=true"
import script from "./Briva.vue?vue&type=script&lang=js"
export * from "./Briva.vue?vue&type=script&lang=js"
import style0 from "./Briva.vue?vue&type=style&index=0&id=4935160b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935160b",
  null
  
)

export default component.exports